import Parseable from '@/misc/Parseable';
import { UserApiEntity } from '@/interfaces/UserApiEntity.interface';

/**
 * A user object
 */
export default class User extends Parseable {
    id?: string;
    email!: string;
    password!: string;

    public static parseFromObject(object: UserApiEntity): User {
        const user = new User();
        user.id = object.id;
        user.email = object.email;
        user.password = object.password;

        return user;
    }

    public parseToObject(): Partial<User> {
        return { ...this };
    }
}
